export const courseColumns = [
  { header: "Unique ID", key: "uniqueId", width: 20 },
  { header: "Course Name", key: "courseName", width: 20 },
  { header: "Certificate Number", key: "certificateNumber", width: 20 },
  { header: "Abbreviation", key: "abbreviation", width: 25 },
  { header: "Issue Date", key: "issueDate", width: 20 },
  { header: "Expiry Date", key: "expiryDate", width: 20 },
  { header: "Remarks", key: "remark", width: 20 },
];
